import movementTypes from 'modules/transactions/constants/movementTypes';
import transactionTypes from 'constants/transactionTypes';
import { createMovement } from 'modules/transactions/utils/createMovement';
import { createTransaction } from 'modules/transactions/utils/createTransaction';

import { HistoryMovement, Movement, Range, Transaction } from 'types';

import { BaseDataForCapitalDecrease } from '../constants/baseDataForCapitalDecrease';

type BuildMockDataResult = {
  movements: Movement[];
  historyMovements: HistoryMovement[];
  transactions: Transaction[];
  totalSharesToDecrease: number;
};

export const buildMockDataFromBaseData = (
  baseData: BaseDataForCapitalDecrease
): BuildMockDataResult => {
  const movements: Movement[] = [];
  const historyMovements: HistoryMovement[] = [];
  const transactions: Transaction[] = [];
  let totalSharesToDecrease = 0;

  baseData.partners.forEach((partner) => {
    const { partnerId, partnerName, rangeFrom, rangeTo, sharesToDecrease } =
      partner;

    if (sharesToDecrease <= 0) return;

    totalSharesToDecrease += sharesToDecrease;

    const rangeToRemove: Range = {
      from: rangeFrom,
      to: rangeTo,
      partner: partnerId,
      shareClass: baseData.shareClassId,
    };

    const decrementMovement = createMovement({
      range: rangeToRemove,
      movementType: movementTypes.DECREMENT,
    });
    movements.push(decrementMovement);

    const remainingFrom = rangeFrom + sharesToDecrease;
    if (remainingFrom <= rangeTo) {
      const rangeToAdd: Range = {
        from: remainingFrom,
        to: rangeTo,
        partner: partnerId,
        shareClass: baseData.shareClassId,
      };
      const incrementMovement = createMovement({
        range: rangeToAdd,
        movementType: movementTypes.INCREMENT,
      });
      movements.push(incrementMovement);
    }

    historyMovements.push({
      from: rangeToRemove.from,
      to: rangeToRemove.to,
      holdingClassName: baseData.holdingClassName,
      partnerNameSeller: partnerName,
      sharePrice: baseData.sharePrice,
    });

    const transaction = createTransaction({
      range: {
        from: rangeToRemove.from,
        to: rangeToRemove.to,
        partner: partnerId,
        shareClass: baseData.shareClassId,
        sharePrice: baseData.sharePrice,
      },
      transactionType: transactionTypes.CAPITAL_DECREASE,
    });
    transactions.push(transaction);
  });

  return {
    movements,
    historyMovements,
    transactions,
    totalSharesToDecrease,
  };
};
